/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyEditedWarningContainer_comment = {
    readonly editing: {
        readonly edited: boolean;
    };
    readonly revision: {
        readonly id: string;
    } | null;
    readonly " $refType": "ReplyEditedWarningContainer_comment";
};
export type ReplyEditedWarningContainer_comment$data = ReplyEditedWarningContainer_comment;
export type ReplyEditedWarningContainer_comment$key = {
    readonly " $data"?: ReplyEditedWarningContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyEditedWarningContainer_comment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyEditedWarningContainer_comment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "EditInfo",
            "kind": "LinkedField",
            "name": "editing",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "edited",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "CommentRevision",
            "kind": "LinkedField",
            "name": "revision",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = '06a357b581b594110e8d93b862548fa5';
export default node;
